<div class="cat__menu-left__logo-placeholder"></div>
<cat-menu-left></cat-menu-left>
<cat-top-bar></cat-top-bar>
<div class="cat__content">
    <router-outlet></router-outlet>
    <cat-footer *ngIf="!progressService.isRoutingChangeInProgress"></cat-footer>
</div>
